module.exports = __webpack_public_path__ + "media/images/landing__teaser__boxDeco--mobile-b1e015d10dda3e2f835baf8c9a5b7e43.png";